module.exports = __webpack_public_path__ + "static/filter_categories_and_all_day-ef5305f222af1254d81c6197e8d4f1b8.png";